import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-xl text-center space-y-6">
        <p className="text-sm font-bold tracking-widest text-[#0077b6]">ERREUR 404</p>
        <h1 className="text-4xl font-bold text-[#1a3a5c]">Page introuvable</h1>
        <p className="text-lg text-slate-600">La page demandée n’existe pas ou a été déplacée.</p>
        <Link className="inline-flex rounded-full bg-[#0077b6] px-6 py-3 font-semibold text-white hover:bg-[#005f8f]" to="/">Retour à l’accueil</Link>
      </div>
    </div>
  );
}
